import IFDOrder from './IFDOrder';

export default IFDOrder;
